export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.001 2c5.523 0 10 4.478 10 10.001a1.002 1.002 0 01-1.333.943c-3.384-1.194-5.648-1.306-7.667-1.073V19A3 3 0 017 19v-1h2v1a1 1 0 002.001 0v-6.803c-2.177.431-4.588 1.034-8.066.802A1 1 0 012 12.001C2.001 6.478 6.478 2 12.001 2zm0 2.001a8 8 0 00-7.942 7.043c3.021.063 5.037-.553 7.394-.966 2.345-.41 4.81-.55 8.421.509A8 8 0 0012.001 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};